<template>
    <div class="min-h-full">
        <TransitionRoot as="template" :show="sidebarOpen">
            <Dialog as="div" class="fixed inset-0 flex z-40 lg:hidden" @close="sidebarOpen = false">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300"
                                 enter-from="opacity-0" enter-to="opacity-100"
                                 leave="transition-opacity ease-linear duration-300" leave-from="opacity-100"
                                 leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75"/>
                </TransitionChild>
                <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
                                 enter-from="-translate-x-full" enter-to="translate-x-0"
                                 leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
                                 leave-to="-translate-x-full">
                    <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-cyan-700">
                        <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                                         enter-to="opacity-100" leave="ease-in-out duration-300"
                                         leave-from="opacity-100" leave-to="opacity-0">
                            <div class="absolute top-0 right-0 -mr-12 pt-2">
                                <button type="button"
                                        class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                        @click="sidebarOpen = false">
                                    <span class="sr-only">Close sidebar</span>
                                    <XMarkIcon class="h-6 w-6 text-white" aria-hidden="true"/>
                                </button>
                            </div>
                        </TransitionChild>
                        <div class="flex-shrink-0 flex items-center px-4">
                            <img alt="logo" class="w-auto" src="/img/cover-white.png"/>
                        </div>
                        <nav class="mt-5 flex-shrink-0 h-full overflow-y-auto"
                             aria-label="Sidebar">

                            <template v-for="group in navigation">
                                <nav-divider :text="group.name"></nav-divider>

                                <div class="px-2 space-y-1">
                                    <button v-for="item in group.items"
                                            :key="item.name"
                                            @click="navigate(item.route)"
                                            :class="[route().current(item.current) ? 'bg-cyan-800 text-white w-full' : 'w-full text-cyan-100 hover:text-white hover:bg-cyan-600', 'group flex items-center px-2 py-2 text-base font-medium rounded-md']"
                                            :aria-current="route().current(item.current) ? 'page' : undefined">
                                        <component :is="item.icon" class="mr-4 flex-shrink-0 h-6 w-6 text-cyan-200"
                                                   aria-hidden="true"/>
                                        {{ item.name }}
                                    </button>
                                </div>
                            </template>
                        </nav>
                    </div>
                </TransitionChild>
                <div class="flex-shrink-0 w-14" aria-hidden="true">
                    <!-- Dummy element to force sidebar to shrink to fit close icon -->
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Static sidebar for desktop -->
        <div class="hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0">
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <div class="flex flex-col flex-grow bg-cyan-700 pt-5 pb-4 overflow-y-auto">
                <div class="flex items-center flex-shrink-0 px-4">
                    <img alt="logo" class="w-auto" src="/img/cover-white.png"/>
                </div>


                <nav class="mt-5 flex-1 flex flex-col overflow-y-auto" aria-label="Sidebar">
                    <template v-for="group in navigation">
                        <nav-divider :text="group.name"></nav-divider>

                        <div class="px-2 space-y-1">
                            <button v-for="item in group.items"
                                    :key="item.name"
                                    @click="navigate(item.route)"
                                    :class="[route().current(item.current) ? 'bg-cyan-800 text-white w-full' : 'text-cyan-100 w-full hover:text-white hover:bg-cyan-600', 'group flex items-center px-2 py-2 text-base font-medium rounded-md']"
                                    :aria-current="route().current(item.current) ? 'page' : undefined">
                                <component :is="item.icon" class="mr-4 flex-shrink-0 h-6 w-6 text-cyan-200"
                                           aria-hidden="true"/>
                                {{ item.name }}
                            </button>
                        </div>
                    </template>
                </nav>
            </div>
        </div>

        <!-- removed z-10 -->
        <div class="lg:pl-64 flex flex-col flex-1">
            <div class="relative flex-shrink-0 flex h-16 bg-white border-b border-gray-200">
                <button type="button"
                        class="px-4 border-r border-gray-200 text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500 lg:hidden"
                        @click="sidebarOpen = true">
                    <span class="sr-only">Open sidebar</span>
                    <Bars3CenterLeftIcon class="h-6 w-6" aria-hidden="true"/>
                </button>
                <!-- Search bar -->
                <div class="flex-1 px-4 flex justify-between sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-8">
                    <div class="flex-1 flex">
                        <form class="w-full flex md:ml-0" action="#" method="GET">
                            <label for="search-field" class="sr-only">Search</label>
                            <div class="relative w-full text-gray-400 focus-within:text-gray-600">
                                <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none"
                                     aria-hidden="true">
                                    <MagnifyingGlassIcon class="h-5 w-5" aria-hidden="true"/>
                                </div>
                                <input id="search-field" name="search-field"
                                       class="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:border-transparent sm:text-sm"
                                       placeholder="Search transactions" type="search"/>
                            </div>
                        </form>
                    </div>
                    <div class="ml-4 flex items-center md:ml-6">
                        <button type="button"
                                class="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                            <span class="sr-only">View notifications</span>
                            <BellIcon class="h-6 w-6" aria-hidden="true"/>
                        </button>

                        <!-- Profile dropdown -->
                        <Menu as="div" class="ml-3 relative">
                            <div>
                                <MenuButton
                                    class="max-w-xs bg-white rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 lg:p-2 lg:rounded-md lg:hover:bg-gray-50">
                                    <span class="hidden ml-3 text-gray-700 text-sm font-medium lg:block"><span
                                        class="sr-only">Open user menu for </span> {{ $page.props.auth.user.name }}</span>
                                    <ChevronDownIcon class="hidden flex-shrink-0 ml-1 h-5 w-5 text-gray-400 lg:block"
                                                     aria-hidden="true"/>
                                </MenuButton>
                            </div>
                            <transition enter-active-class="transition ease-out duration-100"
                                        enter-from-class="transform opacity-0 scale-95"
                                        enter-to-class="transform opacity-100 scale-100"
                                        leave-active-class="transition ease-in duration-75"
                                        leave-from-class="transform opacity-100 scale-100"
                                        leave-to-class="transform opacity-0 scale-95">
                                <MenuItems
                                    class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    <dropdown-link :href="route('profile.show')">
                                        Profil
                                    </dropdown-link>

                                    <form @submit.prevent="logout">
                                        <dropdown-link as="button">
                                            Log Out
                                        </dropdown-link>
                                    </form>

                                </MenuItems>
                            </transition>
                        </Menu>
                    </div>
                </div>
            </div>

            <main class="ml-3 mr-3 flex-1 pb-8">
                <slot></slot>
            </main>

        </div>

        <Toast></Toast>
        <ComponentModal></ComponentModal>

    </div>

</template>

<script>
import {ref} from 'vue'
import {
    Dialog,
    DialogOverlay,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'
import {
    AdjustmentsVerticalIcon,
    ArrowTrendingUpIcon,
    Bars2Icon,
    Bars3CenterLeftIcon,
    BellIcon,
    ChevronDoubleRightIcon,
    CircleStackIcon,
    PaperAirplaneIcon,
    PresentationChartBarIcon,
    XMarkIcon
} from '@heroicons/vue/24/outline'
import {
    ArchiveBoxIcon,
    BanknotesIcon,
    BuildingOfficeIcon,
    ChartBarIcon,
    CheckCircleIcon,
    ChevronDownIcon,
    ChevronRightIcon,
    MagnifyingGlassIcon,
} from '@heroicons/vue/20/solid'
import NavDivider from "../Shared/Components/NavDivider";
import DropdownLink from "../Jetstream/DropdownLink";
import Toast from "../Shared/Components/Toast";
import ComponentModal from "@/Shared/Components/ComponentModal";

const navigation = [
    {
        name: 'Allgemein', items: [
            {name: 'Dashboard', icon: ChartBarIcon, route: 'dashboard', current: 'dashboard'},
        ],
    },
    {
        name: 'Verkauf', items: [
            {
                name: 'Monitoring',
                href: '#',
                icon: PresentationChartBarIcon,
                route: 'sales.monitoring.index',
                current: 'sales.monitoring.*'
            },
            {
                name: 'Aufträge',
                href: '#',
                icon: ArrowTrendingUpIcon,
                route: 'sales.orders.index',
                current: 'sales.orders.*'
            },
            {
                name: 'Kanalmeldungen',
                href: '#',
                icon: PaperAirplaneIcon,
                route: 'sales.outbox.index',
                current: 'sales.outbox.*'
            },
        ],
    },
    {
        name: 'Artikelstamm', items: [
            {name: 'Produkte', icon: ArchiveBoxIcon, route: 'articles.index', current: 'articles.*'},
        ],
    },
    {
        name: 'Lager', items: [
            {
                name: 'Bewegungen',
                icon: ChevronDoubleRightIcon,
                route: 'inventory.movements.index',
                current: 'inventory.movements.*'
            },
        ],
    },
    {
        name: 'System', items: [
            {name: 'Job Management', icon: CircleStackIcon, route: 'settings.jobs.index', current: 'settings.jobs.*'},
            {
                name: 'Integrationen',
                icon: AdjustmentsVerticalIcon,
                route: 'settings.integrations.index',
                current: 'settings.integrations.*'
            },
            // {name: 'Horizon', href: '#', icon: ExternalLinkIcon, current: false},
        ],
    },

]


export default {
    components: {
        ComponentModal,
        NavDivider,
        Dialog,
        DialogOverlay,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        TransitionChild,
        TransitionRoot,
        BellIcon,
        BanknotesIcon,
        CheckCircleIcon,
        ChevronDownIcon,
        ChevronRightIcon,
        Bars2Icon,
        BuildingOfficeIcon,
        MagnifyingGlassIcon,
        XMarkIcon,
        DropdownLink,
        Bars3CenterLeftIcon,
        Toast,
        PresentationChartBarIcon
    },
    setup() {
        const sidebarOpen = ref(false)

        return {
            navigation,
            sidebarOpen,
        }
    },
    methods: {
        logout() {
            this.$inertia.post(this.route('logout'));
        },
        navigate(route) {
            this.$inertia.visit(this.route(route));
            this.sidebarOpen = false;
        }
    }
}
</script>
